<template>
  <ApprovalsHub v-if="flags.enabledApprovalsHub" />
  <ApprovalsTabs v-else />
</template>

<script setup lang="ts">
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

import ApprovalsHub from './Hub/Index.vue'
import ApprovalsTabs from './ApprovalsTabs.vue'

// Home de /aprovacoes: com a flag ligada é o hub em cards (uma rota por fila,
// ver Hub/queues.ts); desligada, o shell de abas histórico com `?tab=`.
const { flags } = useFeatureFlags()
</script>
